module.exports = __webpack_public_path__ + "img/brush-grayD.ae5048c8.png";